import { AggregationTerm, FilterOpts, MusicType } from './types'

export const SUBFACETS: { [key in AggregationTerm]?: { [key: string]: string } } = {
  [AggregationTerm.FORMAT]: {
    choral: AggregationTerm.SIMPLIFIED_VOICINGS,
    exercise: AggregationTerm.EXERCISE_FORMAT,
  },
}

export const FILTERS: { [key in AggregationTerm]: FilterOpts } = {
  [AggregationTerm.MUSIC_SOURCE]: {
    order: 0,
  },
  [AggregationTerm.FORMAT]: {
    order: 1,
  },
  [AggregationTerm.INSTRUMENTS]: {
    order: 2,
    translationPrefix: 'genericInstrument',
  },
  [AggregationTerm.GENRES]: {
    order: 3,
    translationPrefix: 'genre',
  },
  [AggregationTerm.DIFFICULTY]: {
    order: 4,
    translationPrefix: 'difficultyLevel',
  },
  [AggregationTerm.OPENING_KEY]: {
    order: 5,
  },
  [AggregationTerm.DURATION]: {
    order: 6,
  },
  [AggregationTerm.SIMPLIFIED_VOICINGS]: {
    order: null,
  },
  [AggregationTerm.EXERCISE_FORMAT]: {
    order: null,
  },
  [AggregationTerm.GRADE_LEVELS]: {
    order: null,
  },
}

export const MUSIC_TYPE_ORDER = Object.freeze({
  [MusicType.PREMIUM_CONTENT]: 0,
  [MusicType.ARRANGEME_CONTENT]: 1,
  [MusicType.FREE_LIBRARY]: 2,
  [MusicType.EE_BAND_BOOK1]: 3,
  [MusicType.EE_BAND_BOOK2]: 4,
  [MusicType.EE_BAND_BOOK3]: 5,
  [MusicType.EE_STRING_BOOK1]: 6,
  [MusicType.EE_STRING_BOOK2]: 7,
  [MusicType.EE_STRING_BOOK3]: 8,
})
